import { FloorAnalyticsView } from "src/core/enums/floor-analytics-enums";
import { FloorShape } from "src/shared/models/floorPlan";

interface HoverTooltipComponentProps {
  isVisible: boolean;
  position: { x: number; y: number };
  shape: FloorShape | null;
  viewType: FloorAnalyticsView;
  heatmapMotionInfo?: {
    count: number | null;
    sgHour: number;
  };
  lightOPStatusInfo?: {
    status: string | null;
    sgHour: number;
  };
}

const HoverTooltipComponent: React.FC<HoverTooltipComponentProps> = ({
  isVisible,
  position,
  shape,
  viewType,
  heatmapMotionInfo,
  lightOPStatusInfo,
}) => {
  if (!isVisible || !shape) return null;

  return (
    <div>
      <div
        className="hovered-tooltip-container"
        style={{
          position: "absolute",
          top:
            position.y -
            (viewType === FloorAnalyticsView.PLAYBACK_VIEW_MOTION ||
              viewType === FloorAnalyticsView.PLAYBACK_VIEW_LIGHT_STATUS
              ? 75
              : 55),
          left: position.x - 150,
          maxWidth: `${shape?.assetCode?.length * 1.5}rem`,
          backgroundColor: "white",
          padding: "8px 12px",
          borderRadius: "6px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          border: "1px solid #ddd",
          zIndex: 1000,
        }}
      >
        <div className="d-flex hovered-tooltip-text">
          <div
            className="hovered-tooltip-text fw-bold"
            style={{ minWidth: "100px" }}
          >
            Asset ID:
          </div>
          <div className="ms-2 hovered-tooltip-text">{shape.assetCode}</div>
        </div>
        <div className="d-flex hovered-tooltip-text">
          <div
            className="hovered-tooltip-text fw-bold"
            style={{ minWidth: "100px" }}
          >
            Display Name:
          </div>
          <div className="ms-2 hovered-tooltip-text">
            {shape.sensorDisplayName}
          </div>
        </div>
        <div className="d-flex hovered-tooltip-text">
          <div
            className="hovered-tooltip-text fw-bold"
            style={{ minWidth: "100px" }}
          >
            Location:
          </div>
          <div className="ms-2 hovered-tooltip-text">
            {shape.displayLocationName}
          </div>
        </div>

        {viewType === FloorAnalyticsView.PLAYBACK_VIEW_MOTION && heatmapMotionInfo && (
          <div className="d-flex hovered-tooltip-text">
            <div
              className="hovered-tooltip-text fw-bold"
              style={{ minWidth: "100px" }}
            >
              Motion Count:
            </div>
            <div className="ms-2 hovered-tooltip-text">
              {heatmapMotionInfo.count !== null
                ? heatmapMotionInfo.count
                : "N/A"}
            </div>
          </div>
        )}
        {viewType === FloorAnalyticsView.PLAYBACK_VIEW_LIGHT_STATUS &&
          lightOPStatusInfo && (
            <div className="d-flex hovered-tooltip-text">
              <div
                className="hovered-tooltip-text fw-bold"
                style={{ minWidth: "100px" }}
              >
                Light Status:
              </div>
              <div className="ms-2 hovered-tooltip-text">
                {lightOPStatusInfo.status !== null
                  ? lightOPStatusInfo.status
                  : "Off"}
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

export default HoverTooltipComponent;
